import ContentModal from '../trailerBuild/contentModal';

export default class DealerLocatorModal extends ContentModal {
  static selector = '[comp-dealer-locator-modal]';

  constructor(...args) {
    super(...args);

    this.$state.dataLoaded = false;
    this.closeBtn = this.$container.querySelector('[comp-dealer-locator-close]');

    document.addEventListener('dealer-locator:open', () => this.showMenu());
    // Only close on select when actually open — autoLocate() also fires select.
    document.addEventListener('dealer-locator:select', () => {
      if (this.$state.open) this.hideMenu();
    });
    // Allow other components (e.g. the landing contact modal's Back button) to
    // close the picker programmatically.
    document.addEventListener('dealer-locator:close', () => this.hideMenu());

    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.hideMenu());
    }

    this.$container.addEventListener('click', (e) => {
      if (e.target === this.$container) {
        this.hideMenu();
      }
    });
  }

  hideMenu() {
    this.$container.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
    this.$state.open = false;
    // Let a parent modal (e.g. the landing contact modal stacked underneath)
    // re-assert its own scroll lock now that this picker has closed.
    document.dispatchEvent(new CustomEvent('dealer-locator:closed'));
  }

  showMenu() {
    super.showMenu();

    if (!this.$state.dataLoaded) {
      this.fetchDealers();
    }

    document.dispatchEvent(new CustomEvent('dealer-locator:modal-opened'));
  }

  fetchDealers() {
    fetch('/api/dealers')
      .then((res) => res.json())
      .then((dealers) => {
        this.$state.dataLoaded = true;
        document.dispatchEvent(new CustomEvent('dealer-locator:data-loaded', { detail: { dealers } }));
      })
      .catch(() => {});
  }
}
